import { type Doc, EditorSerializer } from "@smartsuite/smartdoc";
import type { FormStyle } from "@smartsuite/types";
import type { FC } from "react";

import { getFormFooterEnabled } from "../../helpers/formStyle";
import {
  fullPresetExtensions,
  usePublicEditorExtensions,
} from "../../helpers/publicMentionExtension";

import "./FormFooter.sass";

export interface FormFooterProps {
  style?: FormStyle | null;
}

const FormFooterImpl: FC<FormFooterProps> = ({ style }) => {
  const extensions = usePublicEditorExtensions(fullPresetExtensions);

  // When the footer is enabled the container always renders, even with empty
  // content, so a selected background color stays visible (story §6.5). The
  // background color is applied via the `--form-footer-bg-color` custom property
  // set on the page container (see PageContentBox), matching how the
  // header/button colors work.
  if (!getFormFooterEnabled(style)) {
    return null;
  }

  // `footer_content` is stored as a raw smartdoc document. The two `Doc` types
  // (@smartsuite/types vs @smartsuite/smartdoc) are structurally identical but
  // declared separately, so a cast is needed to hand it to the serializer.
  // `EditorSerializer` renders the document to static HTML (read-only), the same
  // way the builder renders the footer.
  const doc = (style?.footer_content ?? null) as Doc | null;

  return (
    <div className="form-footer" data-testid="form-footer">
      <EditorSerializer
        className="form-footer__editor ProseMirror--forms"
        doc={doc}
        extensions={extensions}
      />
    </div>
  );
};

export const FormFooter = FormFooterImpl;
